import type { HiddenImageVisibilityState, ImageVisibilityState } from '@ikegps/core-api';
import { CollectionModelHiddenImageVisibility } from '../imageVisibility/hidden.imageVisibility';
import { CollectionModelImageVisibility } from '../imageVisibility/imageVisibility';

function writeHiddenImageVisibility(imageVisibility: CollectionModelHiddenImageVisibility): HiddenImageVisibilityState {
	const state = imageVisibility.state;

	const hidden = state.hidden;

	return {
		id: state.id,
		tag: 'hidden',
		hidden,
	};
}

export class ImageVisibilityWriter {
	static write(imageVisibility: CollectionModelImageVisibility): ImageVisibilityState {
		if (CollectionModelHiddenImageVisibility.isHidden(imageVisibility)) {
			return writeHiddenImageVisibility(imageVisibility);
		}

		throw new Error(`Unexpected drawable: ${imageVisibility.id}:${imageVisibility.state.tag}`);
	}
}
